import { API } from './api';
import { GW_SERVICES_PREFIXES } from '../constants/gateway';

const { REQ } = GW_SERVICES_PREFIXES;

/** Получение списка обращений */
export const GetTicketsList = (params: any) =>
  API.get(`/${REQ}/appeal/tenant/`, params);

/** Создание обращения */
export const CreateTicket = (params: any) =>
  API.post(`/${REQ}/appeal/tenant/`, params);

/** Резерв id для файла в обращении */
export const ReserveTicketFile = (params: {
  filename: string;
}): Promise<{ shared_id: string; file_id: string }> =>
  API.get(`/${REQ}/files/reserve/`, params);

/** Получение shared_id для скачивания файла с микросервиса файлов. */
export const GetTicketFileSharedId = (params: {
  file_ids: string;
  filenames: string;
}): Promise<{ shared_id: string }> =>
  API.get(`/${REQ}/files/temporary/`, params);

/** Отозвать обращение */
export const RevokeTicket = (ticketID: string) =>
  API.patch(`/${REQ}/appeal/tenant/${ticketID}/revoke/`);

/** Оценить обращение */
export const RateTicket = (ticketID: string, params: any) =>
  API.patch(`/${REQ}/appeal/tenant/${ticketID}/rate/`, params);

/** Получение списка тем */
export const GetTicketTopics = () => API.get(`/${REQ}/appeal/topic/`);
